// extracted by mini-css-extract-plugin
export default {"addNewIcon":"styles_addNewIcon__KvyiK","label":"styles_label__BrpEx"};